<template>
  <main class="bg-white">
    <v-container fluid class="pa-0 licence">
      <v-toolbar flat class="main-header main-header__shadow mb-6 px-5 py-2">
        <v-toolbar-title class="main-header__title">
          <h1>
            <v-icon class="mx-3 mb-1" @click="back">mdi-arrow-left</v-icon
            >{{ $t("states") }}
          </h1>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="my-auto mx-1 radius-12 text-capitalize"
            color="success"
            :to="`/countries/${$route.params.id}/states/create`"
          >
            <v-icon>mdi-plus</v-icon>
            <span class="mx-2">{{ $t("add_state") }}</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :loading="loadingDataTable"
        :items="states"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        hide-default-footer
        class="table teams mx-5"
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <read-more
                more-str="more"
                less-str="less"
                :max-chars="15"
                :text="item.name || '---'"
                class="mb-0 major-description m-b-0"
              ></read-more>
            </td>

            <td class="table__cell text-center">
              <strong class="err" v-if="item.available"
                ><v-icon color="success">mdi-check-circle</v-icon></strong
              >
              <strong v-else
                ><v-icon color="error">mdi-close-circle</v-icon></strong
              >
            </td>

            <td
              class="table__cell text-center d-flex align-center justify-center"
            >
              <v-btn
                icon
                small
                :to="`/countries/${$route.params.id}/states/edit/${item.id}`"
                ><v-icon small color="primary">mdi-pencil</v-icon></v-btn
              >
              <v-btn icon small>
                <v-icon class="delete" small @click="handleDelete(item, index)">
                  mdi-delete
                </v-icon></v-btn
              >
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- pagination -->
      <div class="text-xs-center my-10">
        <v-pagination
          v-if="states.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
    </v-container>
    <global-image-preview
      :showDialog="imageOverlay"
      :imagePath="currentPreviewImage"
      @closePreview="imageOverlay = false"
    />
  </main>
</template>
<script>
import TableHeaders from "@/helpers/TableHeaders";
import { IndexData, UpdateData, DeleteData } from "@/helpers/apiMethods";
import { isEqual } from "lodash";
import cookie from "js-cookie";
export default {
  data() {
    return {
      zero: 0,
      dialog: false,
      showDialogData: false,
      locale: cookie.get("language") || "en",
      headers: [],
      states: [],
      loadingDataTable: false,
      loadingData: false,
      licenceShow: {},
      pagination: {},
      queries: {},
      imageOverlay: false,
      currentPreviewImage: ""
    };
  },
  components: {},
  created() {
    this.createTableHeaders();
  },
  methods: {
    indexstates(query) {
      this.loadingDataTable = true;
      IndexData({
        reqName: `admin-panel/countries/${this.$route.params.id}/states`,
        query
      })
        .then(res => {
          const { data, meta } = res.data;
          this.states = data;
          this.pagination = meta;
          this.loadingDataTable = false;
        })
        .catch(() => {})
        .finally(() => {});
    },
    showImagePreview(image) {
      if (image) {
        this.currentPreviewImage = image;
        this.imageOverlay = true;
      }
    },
    back() {
      history.go(-1);
    },
    createTableHeaders() {
      const headersList = ["name", "available", "actions"];
      this.headers = TableHeaders(headersList);
    },
    blockEmployee({ id }) {
      const formData = new FormData();
      formData.append(`is_blocked`, 1);
      formData.append("_method", "put");
      formData.append("locale", this.locale);
      this.popUp().then(value => {
        if (!value.dismiss) {
          UpdateData({
            reqName: `admin-panel/states`,
            data: formData,
            id: id
          })
            .then(() => {
              this.indexstates(this.$route.query);
            })
            .catch(err => console.log(err));
        }
      });
    },

    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `admin-panel/countries/${this.$route.params.id}/states`,
            id: id
          })
            .then(() => {
              this.states.splice(index, 1);
            })
            .catch(err => console.log(err));
        }
      });
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    }
  },
  watch: {
    $route: {
      handler(route) {
        const { query } = route;
        this.queries = query;
        this.pagination.current_page = query.page;
        this.indexstates(query);
      },
      immediate: true
    }
  }
};
</script>
